import styled from 'styled-components'

const WrapFilterBankBlock = styled.div`
    display: flex;
    flex-direction: column;
    /* height: 85px; */
    /* padding: 0 20px; */
    margin-bottom: 13px;
    position: relative;
`

const WrapFilterSearch = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    .filter-search{
        width: 100%;
        height: 40px;
    }
    .icon-export{
        cursor: pointer;
        margin-left: 15px;
    }

`

const WrapDropDown = styled.div`
    /* display: flex;
    align-items: center;
    margin: 15px 0 0 15px;
    .info-check{
        margin-right: 25px;
    } */
    position: absolute;
    top: -38px;
    right: 0;
`

export {
    WrapFilterBankBlock,
    WrapFilterSearch,
    WrapDropDown
}